<template>
  <section class="news-section">
    <div class="news-section__inner">
      <app-title class="news-section__title">
        Новости
      </app-title>
      <swiper v-if="swiperInit"
        class="news-section__swiper"
        :modules="modules"
        :breakpoints="{
          320: { slidesPerView: 1, centerdSlides: true },
          640: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }"
        :pagination="{
          el: '._pagination',
          dynamicBullets: true,
        }"
        :speed="800"
        :navigation="{ nextEl: '.news-section__nav_next', prevEl: '.news-section__nav_prev' }">
        <swiper-slide v-for="(newsItem, index) in newsList"
          :key="index"
          class="news-section__slide">
          <NewsCard :news="newsItem" />
        </swiper-slide>
      </swiper>
      <NewsList v-else
        :news-list="newsList" />

    </div>
    <div class="news-section__nav-swiper">
      <div class="news-section__nav_prev">
        <app-svg id="arrow-left"
          width="15"
          height="15" />
      </div>
      <div class="news-section__nav_next">
        <app-svg id="arrow-right"
          width="15"
          height="15" />
      </div>

      <div class="news-section__link">
        <AppButton to="/news"
          :secondary="true">
          Все новости
        </AppButton>
      </div>
    </div>
  </section>
</template>

<script>
import { ref, onMounted } from "vue";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation } from "swiper";
import AppButton from "@/components/ui/AppButton.vue";
import NewsList from "@/components/NewsList.vue";
import NewsCard from "@/components/NewsCard.vue";

export default {
  name: "NewsSection",
  components: {
    Swiper,
    SwiperSlide,
    AppButton,
    NewsList,
    NewsCard,
  },

  setup() {
    const newsList = ref([]);

    onMounted(async () => {
      axios
        .get("/api/news", {
          params: {
            limit: 8,
          },
        })
        .then(({ data }) => {
          newsList.value = data.data;
        });
    });

    return {
      newsList,
      modules: [Navigation],
    };
  },

  data() {
    return {
      swiperInit: true,
    };
  },

  mounted() {
    // this.onSwiperInit();
  },

  methods: {
    onSwiperInit() {
      const media = window.matchMedia("(max-width:639px)");
      const listener = (event) => (this.swiperInit = event.matches);
      listener(media);

      media.addEventListener("change", listener);
    },
  },
};
</script>

<style lang="scss" scoped>
.news-section {
  position: relative;
  padding-top: 64px;
  padding-bottom: 128px;
  background-color: #f6f6f6;
  overflow: hidden;

  &::before {
    position: absolute;
    content: '';
    inset: 0;
    background-color: $white;
    border-top-left-radius: 240px;

    @include desktop {
      border-top-left-radius: 90px;
    }

    @include phone {
      border-top-left-radius: 0;
    }
  }

  @include laptop {
    padding-top: 30px;
    padding-bottom: 50px;
  }

  &__inner {
    @extend %container;
    position: relative;
    z-index: 1;
  }

  &__title {
    margin-bottom: 43px;

    @include laptop {
      margin-bottom: 20px;
    }

    @include tablet {
      &:after {
        display: none !important;
      }
    }
  }

  &__swiper {
    margin: 0 -5px;
  }

  &__slide {
    padding: 0 5px;
  }

  &__nav-swiper {
    display: flex;
    justify-content: center;
    margin-top: 60px;
    flex: none;
    display: flex;
    gap: 10px;
    color: $color_primary;
    position: relative;

    .news-section__nav_next,
    .news-section__nav_prev {
      cursor: pointer;
      width: 46px;
      height: 46px;
      border-radius: 50%;
      border: 1px solid $color_orange-50;
      display: flex;
      align-items: center;
      justify-content: center;

      &.swiper-button-disabled {
        color: $color_grey-15;
        border-color: $color_grey-15;
      }

      flex: none;
      transition: color 0.3s ease,
      border 0.3s ease;

      @include phone {
        width: 32px;
        height: 32px;
      }
    }

    @include phone {
      // display: none;
      justify-content: space-between;
      padding: 0 16px;
      margin-top: 28px;
    }
  }

  &__link {
    @extend %container-narrow;
    display: flex;
    justify-content: flex-end;
    position: absolute;
    bottom: 0;
    margin-left: auto;
    pointer-events: none;

    & * {
      pointer-events: all;
      padding: 16px 60px;
    }

    @include phone {
      justify-content: center;
      left: 50%;
      transform: translateX(-50%);
      margin-left: 0;

      .button {
        height: 32px;
        padding: 8px 20px;
      }
    }
  }
}
</style>
